import { z } from 'zod'
export const deleteNoteSchema = z.object({
  presentationId: z.string().uuid(),
  noteId: z.string().uuid(),
})
export type DeleteNote = z.infer<typeof deleteNoteSchema>
